export default __webpack_public_path__ + "static/media/giftIcon.c4398ce4.png";